import { useEffect, useState } from 'react';
import ProfileAnalyticsService from './profileAnalyticsService';
import { ProfileAnalyticsData } from './types';
import UploadPanel from './components/UploadPanel';
import ProfileAnalyticsDashboard from './ProfileAnalyticsDashboard';

// Internal-Admin view inside Manage Institute: upload control + live preview of the
// resulting dashboard for the selected institute.
interface Props {
    instituteId: string | number;
}

const ProfileAnalyticsAdmin = ({ instituteId }: Props) => {
    const [data, setData] = useState<ProfileAnalyticsData | null>(null);
    const [meta, setMeta] = useState<{ fileName?: string; updatedAt?: string } | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        setLoading(true);
        ProfileAnalyticsService.getDashboard(instituteId)
            .then((res) => {
                if (!active) return;
                setData(res?.data ?? null);
                setMeta(res?.meta ?? null);
            })
            .catch(() => active && setData(null))
            .finally(() => active && setLoading(false));
        return () => {
            active = false;
        };
    }, [instituteId]);

    return (
        <div className="w-100">
            <UploadPanel
                instituteId={instituteId}
                lastFileName={meta?.fileName}
                lastUpdatedAt={meta?.updatedAt}
                onUploaded={(fresh) => {
                    setData(fresh);
                    setMeta({ fileName: fresh.meta?.fileName, updatedAt: fresh.meta?.uploadedAt });
                }}
            />
            {loading ? (
                <div className="text-center p-5 text-muted">
                    <i className="icon-spinner spin font-22 me-2" aria-hidden="true"></i>
                    Loading…
                </div>
            ) : (
                <ProfileAnalyticsDashboard instituteId={instituteId} data={data} embedded />
            )}
        </div>
    );
};

export default ProfileAnalyticsAdmin;
